module.exports = __webpack_public_path__ + "static/media/Home.dfe73d86.jpg";